import { AppBar, AppBarProps, styled } from '@mui/material';

export const FooterAppBar = styled((props: AppBarProps) => (
  <AppBar {...props} color={'secondary'} enableColorOnDark />
))((_theme) => ({}));
